import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=792a731b&scoped=true&"
import script from "./copyright.vue?vue&type=script&lang=ts&"
export * from "./copyright.vue?vue&type=script&lang=ts&"
import style0 from "./copyright.vue?vue&type=style&index=0&id=792a731b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792a731b",
  null
  
)

export default component.exports